import { keepPreviousData } from "@tanstack/react-query";

import { $api } from "@/shared/api";

// Как часто перезапрашивать, пока каталога героя ещё нет: его соберёт проверка устаревших
// на бэкенде (каждые 15 минут, герои без каталога — первыми), экран сбор не ставит.
export const HERO_BUILDS_POLL_INTERVAL_MS = 60_000;

// Сборки из игры, с которыми играют сильные игроки на герое (`GET /api/builds/heroes/{id}`):
// бэкенд собирает их раз в три дня и отдаёт из базы. Каталога ещё нет (`pending`) —
// перезапрашивается раз в минуту. При смене героя прошлый виден, пока не пришёл новый.
export const useHeroBuilds = (heroId: number) =>
  $api.useQuery(
    "get",
    "/api/builds/heroes/{hero_id}",
    { params: { path: { hero_id: heroId } } },
    {
      placeholderData: keepPreviousData,
      refetchInterval: ({ state }) =>
        state.data?.status === "pending" ? HERO_BUILDS_POLL_INTERVAL_MS : false,
    },
  );
